import React, { useContext, useState } from 'react';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { ConnectWallet } from './ConnectWallet';
import { makeStyles } from '@material-ui/styles';
import { Button, Modal, Link } from '@material-ui/core';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
import { Logo } from './Logo';

const useStyles = makeStyles({
    nav: {
        position: 'relative',
        padding: 15,
        paddingBottom: 0
    },
    content: {
        textAlign: 'center',
        minWidth: 500,
        paddingTop: 15
    },
    logo: {
        fontSize: 36,
    },
    utils: {
        position: 'absolute',
        top: 15,
        right: 15,
        textAlign: 'right'
    },
    feedback: {
        maxWidth: 700,
        maxHeight: 600,
        width: '75%',
        height: '75%',
        backgroundColor: 'white',
        position: 'absolute',
        padding: 15,
        border: '1px solid gray',
        borderRadius: 5,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
});

export const Nav = () => {
    const classes = useStyles();
    const [showFeedback, setShowFeedback] = useState(false);
    const { isLoggedIn, metamask } = useContext(AuthContext);
    const location = useLocation();
    const history = useHistory();

    const onLogin = () => {
        if (location.pathname === "/") {
            history.push('/dashboard');
        }
    }

    return (
        <nav className={classes.nav}>
            <Modal open={showFeedback} onClose={() => setShowFeedback(false)}>
                <div className={classes.feedback}>
                    <iframe src="https://tally.so/embed/wQ5zAw?alignLeft=1" width="100%" height="100%" frameBorder="0" marginHeight="0" marginWidth="0" title="What would you like us to know?"></iframe>
                </div>
            </Modal>
            <div className={classes.content}>
                <Link underline='none' component={RouterLink} to="/"><Logo /></Link>
            </div>
            <div className={classes.utils}>
                <Button onClick={() => setShowFeedback(true)}>Got Feedback?</Button>
                {!isLoggedIn && metamask && <ConnectWallet onLogin={onLogin} />}
                {isLoggedIn && location.pathname !== '/' && <Button style={{ color: 'black' }} component={RouterLink} to="/logout">Logout</Button>}
                {' '}
                {isLoggedIn && location.pathname !== '/dashboard' && (
                    <Button variant="outlined" component={RouterLink} to="/dashboard">Dashboard <TrendingFlatIcon /></Button>
                )}
            </div>
        </nav>
    );
}